<template>
  <div class="vx-row">
    <b-card
      :title="getTitulo()"
      class="mb-base"
    >
      <b-alert
        v-if="!isEmitido()"
        color="warning"
        icon-pack="feather"
        icon="icon-alert-triangle"
        class="mb-base"
      >
        <p>
          Seu boleto ainda não foi emitido ou já expirou. Entre em contato com o
          administrador.
        </p>
      </b-alert>
      <b-button
        v-if="isEmitido()"
        variant="outline-primary"
        block
        @click="copy(getLinhaDigitavel())"
      >clique para copiar o código do seu boleto</b-button>

      <p>
        linha completa: {{ getLinhaDigitavel() }}
      </p>
    </b-card>
    <div class="vx-col w-full lg:w-1/1 mb-base">
      <b-card
        title="Detlhes"
        class="mb-base"
        collapse-action
      >
        <b-list-group flush>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            <span>Data Vencimento</span>
            <b-badge
              variant="primary"
              pill
            >
              {{ getDataVenciento() }}
            </b-badge>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            <span>Valor Nominal</span>
            <b-badge
              variant="primary"
              pill
            >
              {{ getValorNominal() }}
            </b-badge>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            <span>Valor Multa</span>
            <b-badge
              variant="primary"
              pill
            >
              {{ getValorMulta() }}
            </b-badge>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            <span>Valor Juros</span>
            <b-badge
              variant="primary"
              pill
            >
              {{ getValorJuros() }}
            </b-badge>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            <span>Valor Correção</span>
            <b-badge
              variant="primary"
              pill
            >
              {{ getValorCorrecao() }}
            </b-badge>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            <span>Valor Cobrado</span>
            <b-badge
              variant="success"
              pill
            >
              {{ getValorCobrado() }}
            </b-badge>
          </b-list-group-item>
        </b-list-group>
      </b-card>
      <b-card
        title="Composição"
        collapse-action
      >
        <b-list-group flush>
          <b-list-group-item
            v-for="item in getComposicao()"
            :key="item.id"
            class="d-flex justify-content-between align-items-center"
          >
            <span>{{ getDescricaoItemComposicao(item) }}</span>
            <b-badge
              variant="primary"
              pill
            >
              {{ getValorItemComposicao(item) }}
            </b-badge>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </div>
  </div>
</template>

<script>
import { BListGroup, BListGroupItem } from 'bootstrap-vue'
import { formatarDataApi } from '@/libs/date-utils'

export default {
  name: 'BoletoCard',
  components: {
    BListGroup,
    BListGroupItem,
  },
  data() {
    return {
      boleto: null,
    }
  },
  created() {
    this.boleto = this.getBoleto(Number(this.$route.params.id))
  },
  methods: {
    getBoleto(id) {
      return this.$store.getters['boleto/getBoleto'](id)
    },
    getTitulo() {
      return `${this.getValorCobrado()} - ${this.getDataVenciento()}`
    },
    getLinhaDigitavel() {
      return this.boleto.numeroBoleto
    },
    getDataVenciento() {
      return formatarDataApi(this.boleto.dataVencimento)
    },
    getValorCobrado() {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(this.boleto.valorCobrado)
    },
    getValorNominal() {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(this.boleto.valorNominal)
    },
    getValorMulta() {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(this.boleto.valorMulta)
    },
    getValorJuros() {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(this.boleto.valorJuros)
    },
    getValorCorrecao() {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(this.boleto.valorCorrecao)
    },
    getComposicao() {
      return this.boleto.composicoes
    },
    getDescricaoItemComposicao(item) {
      return item.itemPlanoConta.nome
    },
    getValorItemComposicao(item) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(item.valorCobrado)
    },
    isEmitido() {
      return this.boleto && this.boleto.boletoEmitido
    },
    copy(barcode) {
      navigator.clipboard.writeText(barcode)
      this.$toast.success('A linha digitável foi copiada.')
    },
  },
}
</script>
